import React from 'react';
import styled, { css } from 'styled-components';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { FontSize, FontType } from '../../../../config/theme/types/themeTypes';
import { StyledWithChildrenProps } from '../../types/StyledWithChildrenProps';

function H4({
  className,
  children,
  ...props
}: StyledWithChildrenProps) {
  return (
    <Header
      className={mergeClassNames('H4', className)}
      {...props}
    >
      {children}
    </Header>
  );
}

const Header = styled.h4 < StyledWithChildrenProps > `
  ${({ theme }) => css`
    ${theme.font(FontType.Strong, FontSize.H4)}
    ${theme.media.tablet} {
      ${theme.font(FontType.Strong, FontSize.H5)}
    }
  `}
`;

export default H4;
